var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCollaborateApprove = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4627_33870)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H44C50.6274 0 56 5.37258 56 12V44C56 50.6274 50.6274 56 44 56H12C5.37258 56 0 50.6274 0 44V12Z",
    fill: "#7FBB00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4627_33870",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H44C50.6274 0 56 5.37258 56 12V44C56 50.6274 50.6274 56 44 56H12C5.37258 56 0 50.6274 0 44V12Z",
    fill: "#BB1919"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4627_33870)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4627_33870)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 28C12 19.1634 19.1634 12 28 12C32.7207 12 36.9639 14.0444 39.8925 17.2962L29.214 28.2412C28.79 28.6781 28.5557 28.9172 28.374 29.0759L28.3529 29.0941L28.3319 29.0759C28.1502 28.9172 27.9159 28.6781 27.4918 28.2412L23.4352 24.0616C22.6659 23.269 21.3997 23.2501 20.6071 24.0194C19.8144 24.7887 19.7955 26.0549 20.5648 26.8475L24.6215 31.0271L24.6668 31.0738C25.0282 31.4462 25.3791 31.8078 25.7009 32.0888C26.0533 32.3965 26.503 32.7292 27.0942 32.9252C27.9115 33.1961 28.7944 33.1961 29.6117 32.9252C30.2029 32.7292 30.6526 32.3965 31.005 32.0888C31.3268 31.8078 31.6776 31.4463 32.039 31.0738L32.039 31.0738L32.0844 31.0271L42.2132 20.6454C43.355 22.8474 44 25.3484 44 28C44 36.8366 36.8366 44 28 44C19.1634 44 12 36.8366 12 28Z",
    fill: "#D9ECB2"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4627_33870",
    x: -10,
    y: -4,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4627_33870"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.027451 0 0 0 0 0.101961 0 0 0 0 0.141176 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4627_33870"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4627_33870",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4627_33870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCollaborateApprove);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/collaborate_approve.9a2ebbe982da93986e85333da167a53d.svg";